<svelte:options runes={false} />

<script>
  import { routeStateContent } from '../route-states.mjs';

  export let routeKey;
  export let state;
  export let onAction = null;
  // `bare` drops the panel wrapper for the empty state, which renders *inside* a
  // route that is still showing its own controls rather than replacing it.
  export let bare = false;

  $: content = routeStateContent(routeKey, state);
</script>

{#if content}
  <svelte:element
    this={bare ? 'div' : 'section'}
    class={bare ? 'route-state' : 'panel route-state'}
    class:payer-shell={!bare && (routeKey === 'invoice' || routeKey === 'pay')}
  >
    <h2>{content.title}</h2>
    {#if content.body}<p class="quiet">{content.body}</p>{/if}
    {#if content.actionLabel && onAction}
      <div class="button-row">
        <button type="button" on:click={onAction}>{content.actionLabel}</button>
      </div>
    {/if}
    <slot />
  </svelte:element>
{/if}
